// src/pages/AnaSayfa.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import HizmetlerPreview from '../components/HizmetlerPreview';
// ❌ Footer artık burada GÖSTERİLMEZ — App.js’de global olarak yönetiliyor
import './AnaSayfa.css';

const kategoriGorselleri = {
  "Vidalı Kompresörler": "/images/kategoriler/vidali.png",
  "Turbo Kompresörler": "/images/kategoriler/turbo.png",
  "Pistonlu Kompresörler": "/images/kategoriler/pistonlu.png",
  "Yağsız Kompresörler": "/images/kategoriler/yagsiz.png",
  "Kurutucular": "/images/kategoriler/kurutucu.png",
  "Hava Tankları": "/images/kategoriler/havatanki.png",
  "Ekipmanlar": "/images/kategoriler/ekipman.png"
};

const AnaSayfa = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [formModu, setFormModu] = useState(false);
  const [form, setForm] = useState({
    isim: '',
    mail: '',
    telefon: '',
    konu: '',
    mesaj: '',
  });

  const [kategoriler, setKategoriler] = useState([]);

  useEffect(() => {
    fetch('/urunler.json')
      .then(res => res.json())
      .then(data => {
        const tumKategoriler = [...new Set(data.map(u => u.kategori))];
        setKategoriler(tumKategoriler);
      })
      .catch(err => {
        console.error('❌ urunler.json veri çekme hatası:', err);
        alert('Ürün verileri yüklenemedi. Lütfen urunler.json dosyasını kontrol edin.');
      });
  }, []);

  useEffect(() => {
    if (location.state?.scrollToTeklif) {
      setFormModu(true);
      setTimeout(() => {
        const hedef = document.getElementById('teklif');
        if (hedef) hedef.scrollIntoView({ behavior: 'smooth' });
      }, 300);
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  useEffect(() => {
    const handleEvent = () => {
      setFormModu(true);
      setTimeout(() => {
        const hedef = document.getElementById('teklif');
        if (hedef) hedef.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    };

    window.addEventListener('teklifTikla', handleEvent);
    return () => window.removeEventListener('teklifTikla', handleEvent);
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const onceki = JSON.parse(localStorage.getItem('teklifBasvurular') || '[]');
    const yeni = { ...form, tarih: new Date().toLocaleString() };
    localStorage.setItem('teklifBasvurular', JSON.stringify([yeni, ...onceki]));
    alert('✅ Mesaj gönderildi. En kısa sürede dönüş yapılacaktır.');
    setForm({ isim: '', mail: '', telefon: '', konu: '', mesaj: '' });
    setFormModu(false);
  };

  const handleBilgiClick = (kategori) => {
    navigate(`/urunler/${encodeURIComponent(kategori)}`);
  };

  const handleSatinalClick = () => {
    setFormModu(true);
    setTimeout(() => {
      const hedef = document.getElementById('teklif');
      if (hedef) hedef.scrollIntoView({ behavior: 'smooth' });
    }, 300);
  };

  return (
    <div className="ana-wrapper">
      {formModu ? (
        <section className="teklif-sahne" id="teklif">
          <div className="teklif-parlaklik-overlay"></div>
          <div className="teklif-arka-efekt" />
          <div className="teklif-parlaklik-alt"></div>

          <div className="teklif-icerik">
            <div className="teklif-baslik-alani">
              <span className="teklif-etiket">PROFESYONEL ÇÖZÜMLER</span>
              <h2>Teklif Al</h2>
              <p>
                İhtiyacınızı bize iletin, <strong>endüstriyel gücünüze</strong> en
                uygun çözümü birlikte tasarlayalım.
              </p>
            </div>

            <form className="form-kutu" onSubmit={handleSubmit}>
              <label>İsim</label>
              <input name="isim" value={form.isim} onChange={handleChange} required />

              <label>Mail</label>
              <input
                type="email"
                name="mail"
                value={form.mail}
                onChange={handleChange}
                placeholder="name@example.com"
                required
              />

              <label>Telefon</label>
              <input
                type="tel"
                name="telefon"
                value={form.telefon}
                onChange={handleChange}
                placeholder="0 (5xx) xxx xxxx"
                required
              />

              <label>Konu</label>
              <input name="konu" value={form.konu} onChange={handleChange} required />

              <label>Mesaj</label>
              <textarea
                name="mesaj"
                rows="5"
                value={form.mesaj}
                onChange={handleChange}
                required
              ></textarea>

              <button type="submit">Mesajı Gönder</button>
            </form>
          </div>
        </section>
      ) : (
        <>
          <Hero />

          <section className="apple-style-products-grid">
            {kategoriler.map((kat, i) => {
              const isEven = i % 2 === 0;
              const bgColor = isEven ? '#e0f0ff' : '#f8f8f8';
              const imageSide = isEven ? 'left' : 'right';

              return (
                <div
                  key={i}
                  className={`product-card apple-${imageSide}`}
                  style={{ backgroundColor: bgColor }}
                >
                  {imageSide === 'left' && (
                    <div className="product-image">
                      <img src={kategoriGorselleri[kat] || '/images/bos-urun.jpg'} alt={kat} />
                    </div>
                  )}

                  <div className="product-content">
                    <h2>{kat}</h2>
                    <p>Endüstriyel verimliliğin kalbi.</p>
                    <div className="product-buttons">
                      <button onClick={() => handleBilgiClick(kat)}>Daha Fazla Bilgi</button>
                      <button onClick={handleSatinalClick}>Teklif Al</button>
                    </div>
                  </div>

                  {imageSide === 'right' && (
                    <div className="product-image">
                      <img src={kategoriGorselleri[kat] || '/images/bos-urun.jpg'} alt={kat} />
                    </div>
                  )}
                </div>
              );
            })}
          </section>

          <HizmetlerPreview />

          <section className="hakkimizda">
            <h2 className="bolum-baslik">Hakkımızda</h2>
            <div className="hakkimizda-icerik">
              <p>
                <strong>Air Makina İmalat Sanayi ve Ticaret Ltd. Şti.</strong>, 2022 yılında{' '}
                <strong>Hamza Elbir</strong> öncülüğünde Adana’da kurulmuş olup,
                endüstriyel hava çözümleri alanında uzmanlaşmış bir mühendislik ve
                servis firmasıdır.
              </p>

              <p>
                Kurucumuz Hamza Elbir, 28 yılı aşkın sektörel tecrübesiyle, özellikle
                Atlas Copco markasında uzun yıllar servis hizmetleri sunmuş; yüksek
                basınçlı hava sistemleri ve kompresör teknolojileri alanında derin
                bir bilgi birikimi kazanmıştır.
              </p>

              <p><strong>Air Makina olarak:</strong></p>

              <ul className="hizmet-listesi">
                <li>Vidalı Kompresörler</li>
                <li>Pistonlu Kompresörler</li>
                <li>Turbo Kompresörler</li>
                <li>Kurutucular</li>
                <li>Basınçlı hava sistemleri</li>
              </ul>

              <p>
                <strong>7/24 teknik servis</strong>, <strong>periyodik bakım</strong>,
                <strong> arıza onarım</strong>, <strong>yedek parça tedariki</strong>,
                <strong> kompresör satışı</strong> ve <strong>kiralama hizmetleri</strong>
                sunmaktayız.
              </p>

              <p>
                Aynı zamanda <strong>Lupamat Yetkili Servisi</strong> olarak faaliyet
                gösteren firmamız, müşteri memnuniyetini ve teknik güvenliği temel
                ilke edinmiştir.
              </p>
            </div>
          </section>

          {/* ❌ Footer kaldırıldı — App.js'de global olarak render ediliyor */}
        </>
      )}
    </div>
  );
};

export default AnaSayfa;